import { render, staticRenderFns } from "./DlgDetailUsedPartByInvoice.vue?vue&type=template&id=1b8df836"
import script from "./DlgDetailUsedPartByInvoice.vue?vue&type=script&lang=js"
export * from "./DlgDetailUsedPartByInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports